export interface AnalysisDownloadGq {
  id: number;
  downloadUrl?: string;
  analysisProgress: number;
  analysisCount: number;
}

export const AnalysisDownloadGqProps = `
    id
    downloadUrl
    analysisProgress
    analysisCount
`;
